import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import useSrlHelper from "../../hooks/useSrlHelper";
import api from "../../api";
import useCommonMap from "../../hooks/useCommonMap";
import { imageSet } from "../../pages/icons/AssetIcon/IconList";
import { getDistance, getUrl } from "../../utils/staticMethods";
import defaultImg from "../../assets/img/icon/Aircraft/Airliner_Black.png";

const ShowZones = ({ includedZones, excludedZones, children }) => {
  const [zones, setZones] = useState();
  const { itemDisplayName } = useSrlHelper();
  const mapItems = useRef([]);
  const { map, mapLibCore, mapLibMarker, mapLibMaps } = useCommonMap();

  useEffect(() => {
    loadZones();
  }, []);

  useEffect(() => {
    console.log("Zones", { Zones: zones, i: includedZones, e: excludedZones });
    if (!zones || !Array.isArray(zones) || zones.length === 0) return;

    const incZones =
      includedZones && Array.isArray(includedZones)
        ? zones.filter((zone) => {
            return includedZones.includes(zone.id);
          })
        : zones.filter((zone) => {
            // Include zone that have no altitude set
            return zone.altitude == null;
          });

    // If we have been passed an array of hidden zone ids, filter the array of zones
    const filteredZones =
      excludedZones && Array.isArray(excludedZones)
        ? incZones.filter((zone) => {
            return !excludedZones.includes(zone.id);
          })
        : incZones;

    filteredZones.forEach((zone) => {
      if (zone.latitude && zone.longitude) {
        let m = new mapLibMarker.AdvancedMarkerElement({
          // id: zone.id,
          // type: "zones",
          // asset: zone.type === "asset" ? 1 : 0,
          // person: zone.type === "person" ? 1 : 0,
          // zone: zone.type === "zone" ? 1 : 0,
          // ids: [zone],
          // idsArr: [zone.id],
          position: {
            lat: Number(zone.latitude),
            lng: Number(Number(zone.longitude)),
          },
          // label: {
          //   text: itemDisplayName(zone),
          //   color: "#000000",
          //   fontWeight: "bold",
          //   className: "marker-position-top",
          // },
          // icon: {
          //   url: imageSet[getUrl(zone.icon)]
          //     ? require("../../assets/img/icon/" + imageSet[getUrl(zone.icon)])
          //         .default
          //     : defaultImg,
          //   scaledSize: new mapLibCore.Size(24, 24),
          //   anchor: new mapLibCore.Point(12, 12),
          // },
          // anchor: new mapLibCore.Point(14, 43),
          map: map,
          // zIndex: 10000000000,
        });
        const imageSrc = imageSet[getUrl(zone.icon)]
          ? require("../../assets/img/icon/" + imageSet[getUrl(zone.icon)])
              .default
          : defaultImg;
        ReactDOM.render(
          <div style={{ position: "relative", transform: "translateY(50%)" }}>
            <img src={imageSrc} width={24} alt="Marker" />

            <div
              className="px-1 text-nowrap text-black bg-secondary bg-opacity-75 rounded"
              style={{
                position: "absolute",
                bottom: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                marginTop: 4,
                pointerEvents: "none",
              }}
            >
              {itemDisplayName(zone)}
            </div>
          </div>,
          m.element
        );
        mapItems.current.push(m);

        // Draw circle or polygon of zone
        if (zone.radius) {
          // m.diam = Number(item.radius) * 2;
          let c = new mapLibMaps.Circle({
            id: zone.id,
            idsArr: [zone.id],
            ids: [zone],
            strokeColor: "#090B29",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#090B29",
            fillOpacity: 0.4,
            shape: "circle",
            type: "zone",
            center: {
              lat: Number(zone.latitude),
              lng: Number(Number(zone.longitude)),
            },
            map: map,
            radius: Number(zone.radius),
          });
          mapItems.current.push(c);
        } else if (zone.polygon) {
          let firstItem = zone.polygon[0].split(",");
          let minLat = {
              lat: Number(firstItem[1]),
              lng: Number(firstItem[0]),
            },
            maxLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
            minLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
            maxLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) };
          let arr = zone.polygon.map((item) => {
            let me = item.split(",");
            let lng = Number(me[0]);
            let lat = Number(me[1]);
            if (lat > maxLat.lat) maxLat = { lat, lng };
            if (lat < minLat.lat) minLat = { lat, lng };
            if (lng > maxLng.lng) maxLng = { lat, lng };
            if (lng < minLng.lng) minLng = { lat, lng };
            return { lng, lat };
          });
          let point1 = new mapLibCore.LatLng(minLat);
          let point2 = new mapLibCore.LatLng(maxLat);
          let point3 = new mapLibCore.LatLng(minLng);
          let point4 = new mapLibCore.LatLng(maxLng);
          let d1 = getDistance(point1, point2);
          let d2 = getDistance(point3, point4);
          let d = d1 > d2 ? d1 : d2;
          m.diam = Number(d);
          let polygon = new mapLibMaps.Polygon({
            paths: arr,
            idsArr: [zone.id],
            id: zone.id,
            ids: [zone],
            type: "zone",
            shape: "polygon",
            strokeColor: "#000000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#242424",
            fillOpacity: 0.4,
            editable: false,
            map: map,
          });
          mapItems.current.push(polygon);
        }
      }
    });

    return () => {
      mapItems.current.forEach((element) => {
        element.setMap(null);
        element = null;
      });
      mapItems.current = [];
    };
  }, [zones, includedZones, excludedZones]);

  const loadZones = () => {
    api.get("zones?page=1&limit=999").then((response) => {
      if (response.data) {
        if (Array.isArray(response.data)) {
          setZones(
            response.data.map((zone) => {
              return { ...zone, type: "zone" };
            })
          );
        }
      }
    });
  };

  return children ?? null;
};

export default ShowZones;
